
import React from "react";

interface UnavailableOverlayProps {
  isUnavailable: boolean;
}

export const UnavailableOverlay: React.FC<UnavailableOverlayProps> = ({ isUnavailable }) => {
  if (!isUnavailable) return null;
  
  return (
    <div className="absolute inset-0 bg-neutral-100 bg-[repeating-linear-gradient(45deg,#888,#888_1px,transparent_1px,transparent_10px)] opacity-50 flex items-center justify-center">
      <div className="hidden sm:block bg-white/80 px-2 py-0.5 rounded text-xs text-neutral-600">
        Non disponibile
      </div>
    </div>
  );
};
